import {RouteView, PageView} from '../layouts'

export const vote = {
  path: '/vote',
  redirect: '/vote/vote',
  meta: { title: '投票活动管理', icon: 'rocket', isMenuShow:true, permission: 'vote'},
  component:PageView,
  children: [
    {
      path: '/vote/vote',
      name: 'vote',
      component: () => import('../views/vote/vote.vue'),
      meta: {title: '寻找最美灰姑娘', icon: 'skin', isMenuShow: true, permission: 'vote:find'},
    },
    {
      path: '/vote/vote/voteDetail',
      name: 'voteDetail',
      component: () => import('../views/vote/voteDetail.vue'),
      meta: {
        title: '用户详情',
        from: {path: '/vote/vote', name: "用户列表"},
        keepAlive: false,
        isMenuShow: false,
        permission: 'vote:find:detail'
      },
    },
    {
      path: '/vote/voteChild',
      name: 'vote',
      component: () => import('../views/vote/voteChild.vue'),
      meta: {title: '童心同行', icon: 'skin', isMenuShow: true, permission: 'vote:find'},
    },
    {
      path: '/vote/vote/voteChildDetail',
      name: 'voteDetail',
      component: () => import('../views/vote/voteChildDetail.vue'),
      meta: {
        title: '投票详情',
        from: {path: '/vote/voteChild', name: "童心同行"},
        keepAlive: false,
        isMenuShow: false,
        permission: 'vote:find:detail'
      },
    },
  ]
}
